import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  rides: [],
  currentRide: null,
  loading: false,
  error: null,
};

const rideSlice = createSlice({
  name: 'rides',
  initialState,
  reducers: {
    setRides: (state, action) => {
      state.rides = action.payload;
      state.loading = false;
    },
    setCurrentRide: (state, action) => {
      state.currentRide = action.payload;
      state.loading = false;
    },
    addRide: (state, action) => {
      state.rides.unshift(action.payload);
    },
    updateRide: (state, action) => {
      const index = state.rides.findIndex(ride => ride.id === action.payload.id);
      if (index !== -1) {
        state.rides[index] = action.payload;
      }
      if (state.currentRide && state.currentRide.id === action.payload.id) {
        state.currentRide = action.payload;
      }
    },
    removeRide: (state, action) => {
      state.rides = state.rides.filter(ride => ride.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setRides,
  setCurrentRide,
  addRide,
  updateRide,
  removeRide,
  setLoading,
  setError,
  clearError,
} = rideSlice.actions;

export default rideSlice.reducer;
